<template>
    <div class="d-flex align-center">
        <v-autocomplete
            @input="isPassed = null"
            v-model="selectedQuestionBanks"
            :items="questionBanks"
            label="Bank soal"
            auto-select-first
            multiple
            small-chips
            clearable
            deletable-chips
            :loading="questionBankLoading"
        ></v-autocomplete>

        <v-btn
            @click="check"
            color="primary"
            small
            class="ml-4"
            :disabled="selectedQuestionBanks.length == 0"
            :loading="similiarityLoading"
        >
            <v-icon left>mdi-cloud-check</v-icon>
            cek bank soal
        </v-btn>

        <similarity-alert :is-passed="isPassed" />
    </div>
</template>

<script>
import SimilarityAlert from './SimilarityAlert.vue'

export default {
    props: {
        tryouts: {
            type: Array,
            required: true
        }
    },

    components: {
        SimilarityAlert
    },

    data: () => ({
        questionBankLoading: false,
        similiarityLoading: false,
        selectedQuestionBanks: [],
        questionBanks: [],
        isPassed: null
    }),

    methods: {
        async check() {
            this.similiarityLoading = true

            const result = {}
            let isSimilarityExists = false
            for (const tryoutIdx in this.tryouts) {
                const tryout = this.tryouts[tryoutIdx]
                const questionIds = tryout.questions.map(
                    question => question.id
                )

                const questionBankIds = this.selectedQuestionBanks.includes(0)
                    ? this.questionBanks.map(questionBank => questionBank.value)
                    : this.selectedQuestionBanks

                const response = await this.$apiv2.get(
                    'question-import/question-bank-similiarity-check',
                    {
                        params: {
                            questionIds: questionIds,
                            questionBankIds
                        }
                    }
                )
                const similiarities = response.data.questions

                for (const questionIdx in tryout.questions) {
                    const question = tryout.questions[questionIdx]
                    const similiarity = similiarities[question.id]

                    if (similiarity === undefined) {
                        continue
                    }

                    if (result[tryoutIdx] === undefined) {
                        result[tryoutIdx] = {}
                    }

                    isSimilarityExists = true
                    result[tryoutIdx][questionIdx] = similiarity
                }
            }

            this.$emit('input', result)
            this.isPassed = !isSimilarityExists
            this.similiarityLoading = false
        }
    },

    async created() {
        this.questionBankLoading = true

        const response = await this.$api.get('questionbank')
        this.questionBanks = response.data.questionbanks.map(questionbank => ({
            text: questionbank.title,
            value: questionbank.id
        }))
        this.questionBanks.push({ text: 'Semua', value: 0 })
        this.questionBanks.reverse()

        this.questionBankLoading = false
    }
}
</script>
